export const paymentsV2GetterTypes = {
    GET_PAYMENT_TYPES: 'paymentsV2/GET_PAYMENT_TYPES',
    GET_BANK_CODES: 'paymentsV2/GET_BANK_CODES',
    GET_PAYMENTS: 'paymentsV2/GET_PAYMENTS',
    GET_CLIENT: 'paymentsV2/GET_CLIENT',
    GET_LOADING: 'paymentsV2/GET_LOADING',
}

export const paymentsV2MutationTypes = {
    SET_PAYMENT_TYPES: 'paymentsV2/SET_PAYMENT_TYPES',
    SET_BANK_CODES: 'paymentsV2/SET_BANK_CODES',
    ADD_PAYMENT: 'paymentsV2/ADD_PAYMENT',
    UPDATE_PAYMENT: 'paymentsV2/UPDATE_PAYMENT',
    REMOVE_PAYMENT: 'paymentsV2/REMOVE_PAYMENT',
    SET_PAYMENT_DESCRIPTION: 'paymentsV2/SET_PAYMENT_DESCRIPTION',
    SET_CLIENT_BY_WIG_ID: 'paymentsV2/SET_CLIENT_BY_WIG_ID',
    SET_CLIENT: 'paymentsV2/SET_CLIENT',
    SET_LOADING: 'paymentsV2/SET_LOADING',
    SET_VAT: 'paymentsV2/SET_VAT',
    SET_COMMENTS: 'paymentsV2/SET_COMMENTS',
    SET_INVOICE_AND_RECEIPT: 'paymentsV2/SET_INVOICE_AND_RECEIPT',
    RESET_STATE: 'paymentsV2/RESET_STATE',
}

export const paymentsV2ActionTypes = {
    FETCH_PAYMENT_TYPES: 'paymentsV2/FETCH_PAYMENT_TYPES',
    FETCH_BANK_CODES: 'paymentsV2/SET_BANK_CODES',
    ADD_PAYMENT: 'paymentsV2/ADD_PAYMENT',
    UPDATE_PAYMENT: 'paymentsV2/UPDATE_PAYMENT',
    REMOVE_PAYMENT: 'paymentsV2/REMOVE_PAYMENT',
    CONFIRM_PAYMENTS: 'paymentsV2/CONFIRM_PAYMENTS',
    SET_PAYMENT_DESCRIPTION: 'paymentsV2/SET_PAYMENT_DESCRIPTION',
    FETCH_CLIENT_BY_WIG_ID: 'paymentsV2/FETCH_CLIENT_BY_WIG_ID',
    SET_CLIENT: 'paymentsV2/SET_CLIENT',
    SET_VAT: 'paymentsV2/SET_VAT',
    SET_COMMENTS: 'paymentsV2/SET_COMMENTS',
    SET_INVOICE_AND_RECEIPT: 'paymentsV2/SET_INVOICE_AND_RECEIPT',
    RESET_STATE: 'paymentsV2/RESET_STATE',
}
